<app-admin-header></app-admin-header>
<div class="container">
    <app-admin-sidebar></app-admin-sidebar>
  <h2>🧑‍⚕️ Staff Activity Logs</h2>

  <input
    type="text"
    placeholder="Search by name, role or action"
    [(ngModel)]="searchTerm"
    (input)="search()"
  />

  <table class="log-table">
    <thead>
      <tr>
        <th>Staff Name</th>
        <th>Role</th>
        <th>Action</th>
        <th>Timestamp</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let log of filteredLogs">
        <td>{{ log.staff_name }}</td>
        <td>{{ log.role }}</td>
        <td>{{ log.action }}</td>
        <td>{{ log.timestamp | date:'short' }}</td>
      </tr>
    </tbody>
  </table>
</div>
